export const CHECK_EUA_AVAILABILITY = "eua/CHECK_EUA_AVAILABILITY";
export const SET_EUA_CHECK_AVAILABILITY = "eua/SET_EUA_CHECK";
export const SET_EUA_CHECK_AVAILABILITY_ERROR = "eua/SET_EUA_ERROR";
export const CLEAR_EUA_AVAILABILITY = "eua/CLEAR_EUA";

export const checkEuaAvailability = (accountId) => ({
  type: CHECK_EUA_AVAILABILITY,
  payload: accountId,
});

export const setEuaCheckAvailability = (data) => ({
  type: SET_EUA_CHECK_AVAILABILITY,
  payload: data,
});

export const setEuaCheckAvailabilityError = (error) => ({
  type: SET_EUA_CHECK_AVAILABILITY_ERROR,
  payload: error,
});

export const clearEuaAvailability = () => ({
  type: CLEAR_EUA_AVAILABILITY,
});
